import type { UploadedFileOriginType, UploadedFileStepType } from '@core/core/types'

type StatusType = UploadedFileStepType | 'timer' | 'pause' | 'error' | 'default'

const TagGroup = [1, 2, 3, 4, 5, 6, 7, 8, 9] as const

type TagProps = {
  label: string
  group: (typeof TagGroup)[number]
}

export type TagData = Record<StatusType, TagProps>

export type UploadedFileOriginItemType = {
  label: string
  id: UploadedFileOriginType | 'all'
}

export const originItems: UploadedFileOriginItemType[] = [
  { label: 'Мои', id: 'localMine' },
  { label: 'Все', id: 'all' },
]
